var map = {
	"./12.jpg": "5b4b",
	"./2.jpg": "e1de",
	"./25.jpg": "e6fe",
	"./7-24-hizmet.png": "aea7",
	"./bilgisayar-markalari.jpg": "7ae1",
	"./misyon-vizyon-degerler.jpg": "71b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "41c6";